import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import AccessDeviceFields from './AccessDeviceFields'

export const AccessDeviceEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <AccessDeviceFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default AccessDeviceEdit
